import {Preview, template as tpl} from "./Preview";
import formdataHtml from './formdata.html?raw';

export let template = tpl.replace('<!-- {{TEMPLATE_ROW}} -->', formdataHtml);

export class viewModel extends Preview {

    constructor(params: any) {
        super(params);
        this.table = [
            {
                key: "id",
                sort: false
            },
            {
                key: "GivenName",
                sort: true
            },
            {
                key: "Surname",
                sort: true
            },
            {
                key: "Kildeid",
                sort: true
            },
        ];
        this.searchcolumn("GivenName");
        this.showAll(true);
    }

}
